module.exports = __webpack_public_path__ + "img/american-credit-get-funded-fast-320w.28fcbcd.png";